import {
  AUTHORIZE_LINK_VALIDATE_REQUEST,
  AUTHORIZE_PASSCODE_VALIDATE_REQUEST,
  AUTHORIZE_PAANS_CHECK_REQUEST,
  AUTHORIZE_LINK_ACTION_DATA_REQUEST,
  AUTHORIZE_LINK_EXPIRE_ON_LINK_REQUEST,
  AUTHORIZE_PASSCODE_ACTION_DATA_REQUEST,
  AUTHORIZE_LINK_GENERATE_VALIDATOR_REQUEST,
  AUTHORIZE_LINK_ENUM_ACTION_TYPE_REQUEST,
  AUTHORIZE_LINK_ENUM_ACTION_VALIDATION_REQUEST,
  AUTHORIZE_LINK_UPDATE_STATUS,
  AUTHORIZE_GET_CONFIRMATION_STATUS_REQUEST,
  AUTHORIZE_GET_DOWNSTREAM_REQUEST_ACTIVE,
  GET_SETTINGS
} from "./constants/actionTypes";

export const validateLink = magicActionValidationRequest => {
  return {
    type: AUTHORIZE_LINK_VALIDATE_REQUEST,
    payload: magicActionValidationRequest
  };
};
export const validatePassCode = passCodeActionValidationRequest => {
  return {
    type: AUTHORIZE_PASSCODE_VALIDATE_REQUEST,
    payload: passCodeActionValidationRequest
  };
};

export const validatePaans = passCodeActionValidationRequest => {
  return {
    type: AUTHORIZE_PAANS_CHECK_REQUEST,
    payload: passCodeActionValidationRequest
  };
};
export const getActionData = actionKey => {
  return {
    type: AUTHORIZE_LINK_ACTION_DATA_REQUEST,
    payload: actionKey
  };
};
export const getActionDetails = encriptedLink => {
  return {
    type: AUTHORIZE_LINK_GENERATE_VALIDATOR_REQUEST,
    payload: encriptedLink
  };
};
export const expireOnTime = actionKey => {
  return {
    type: AUTHORIZE_LINK_EXPIRE_ON_LINK_REQUEST,
    payload: actionKey
  };
};
export const sendPassCode = magicActionValidationRequest => {
  return {
    type: AUTHORIZE_PASSCODE_ACTION_DATA_REQUEST,
    payload: magicActionValidationRequest
  };
};
export const getEnumActionTypes = () => ({
  type: AUTHORIZE_LINK_ENUM_ACTION_TYPE_REQUEST
});
export const getEnumActionValidations = () => ({
  type: AUTHORIZE_LINK_ENUM_ACTION_VALIDATION_REQUEST
});
export const setStatus = status => ({
  type: AUTHORIZE_LINK_UPDATE_STATUS,
  payload: status
});
export const isConfirmationCompleted = actionLink => ({
  type: AUTHORIZE_GET_CONFIRMATION_STATUS_REQUEST,
  payload: actionLink
});
export const isRequestActive = link => ({
  type: AUTHORIZE_GET_DOWNSTREAM_REQUEST_ACTIVE,
  payload: link
});
export const getSettings = actionLink => ({
  type: GET_SETTINGS,
  payload: actionLink
});
